export default {
    filerOutsideHoh: 'TAX_FILER_STATIC_TEXT1'
}